import { InputNumber, message, notification, Tooltip } from "antd";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import Modal from "antd/lib/modal/Modal";

import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";

import FiscalizationStore from "./store/FiscalizationStore";
const fiscalizationstore = createContext(FiscalizationStore);

export const FiscalizationUploadDialog = observer(() => {
  const fiscalizationStore = useContext(fiscalizationstore);

  return (
    <Modal
      title={`${fiscalizationStore.mainStore.assetContextName}-OANDO  ${fiscalizationStore.targetYear} fiscalization Initialization`}
      centered
      visible={fiscalizationStore.showFiscalizationDialog}
      onOk={async () => {
        try {
          await fiscalizationStore.initailizeFiscalzation();
          fiscalizationStore.showFiscalizationDialog = false;
          message.success(
            `${fiscalizationStore.mainStore.assetContextName}-OANDO  ${fiscalizationStore.targetYear} fiscalization Initialization was successfull`
          );
        } catch (error) {
          const { message, response } = error;
          if (response) {
            notification.error({
              message: "SPARS Feedback",
              description: error.response.text,
            });
            return;
          }
          notification.error({
            message: "SPARS Feedback",
            description: message,
          });
        }
      }}
      onCancel={() => {
        fiscalizationStore.showFiscalizationDialog = false;
      }}
      okText="Initialize"
      cancelText="Cancel"
      confirmLoading={fiscalizationStore.isIniatilizing}
    >
      <Form layout="vertical">
        <FormItem
          label={<span style={{ color: "black" }}>Fiscalization Year *</span>}
        >
          <Tooltip title="represent fiscalization year to generate initial fiscalization values">
            <InputNumber
              placeholder="Fiscalization Year"
              value={fiscalizationStore.targetYear}
              defaultValue={fiscalizationStore.targetYear}
              onChange={(value) => {
                fiscalizationStore.targetYear = value;
              }}
              readOnly={true}
              style={{ width: "120px" }}
            />
          </Tooltip>
        </FormItem>
        <FormItem>
          <span style={{ color: "red", fontStyle: "italic" }}>
            Fiscalization Initialization is performed once a year
          </span>
          <br />
          <span style={{ color: "gray", fontStyle: "italic" }}>
            Facility operating capacities figures will be rolled from previous
            year
          </span>
        </FormItem>
      </Form>
    </Modal>
  );
});

